import React from 'react';
import { Form, Input } from 'antd';

const Email = ({ isEditable, validateField, form }) => {
  const { getFieldDecorator } = form;
  const validateEmail = validateField('email');
  return (
    <div className="b-form-fields">
      <div className="b-form-fields__item">
        <Form.Item
          label="E-mail"
          validateStatus={validateEmail.status}
          help={validateEmail.help}
        >
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: 'Не корректный email',
              },
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(
            <Input
              name="email"
              placeholder="Введите e-mail"
              style={{ width: 368 }}
              disabled={!isEditable}
            />
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default Email;
